import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { useAlert } from '../components/GlobalAlert';
import './RegisterPage.css';

function RegisterPage() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const { t } = useLanguage();
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username || !email || !password || !confirmPassword) {
      setError(t('fillAllFields'));
      return;
    }
    if (username.length < 3) {
      setError(t('usernameMinLength'));
      return;
    }
    if (password.length < 6) {
      setError(t('passwordMinLength'));
      return;
    }
    if (password !== confirmPassword) {
      setError(t('passwordMismatch'));
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError(t('invalidEmail'));
      return;
    }
    setLoading(true);
    try {
      const result = await register(username, email, password);
      if (result.success) {
        showAlert(t('registerSuccess'), 'success');
        // ไปหน้า dashboard ทันทีเมื่อ register สำเร็จ
        navigate('/dashboard');
      } else {
        setError(result.message || t('registerError'));
      }
    } catch {
      setError(t('connectionError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg-center">
      <form className="auth-form" onSubmit={handleSubmit} autoComplete="on">
        <h1 className="auth-title">Mellow</h1>
        <h2 className="auth-heading">{t('joinUs')}</h2>
        <p className="auth-sub">{t('registerSubtitle')}</p>
        {error && <div className="auth-error">{error}</div>}
        <div className="auth-input-group">
          <span className="auth-input-icon">👤</span>
          <input
            type="text"
            placeholder={t('enterUsername')}
            value={username}
            onChange={e => setUsername(e.target.value)}
            className="auth-input"
            autoComplete="username"
            required
          />
        </div>
        <div className="auth-input-group">
          <span className="auth-input-icon">✉️</span>
          <input
            type="email"
            placeholder={t('enterEmail')}
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="auth-input"
            autoComplete="email"
            required
          />
        </div>
        <div className="auth-input-group">
          <span className="auth-input-icon">🔒</span>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder={t('enterPassword')}
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="auth-input"
            autoComplete="new-password"
            required
          />
          <button
            type="button"
            className="auth-password-toggle"
            onClick={() => setShowPassword(v => !v)}
            tabIndex={-1}
            aria-label={showPassword ? t('hide') : t('show')}
          >
            {showPassword ? '🙈' : '👁'}
          </button>
        </div>
        <div className="auth-input-group">
          <span className="auth-input-icon">🔒</span>
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            placeholder={t('confirmPassword')}
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            className="auth-input"
            autoComplete="new-password"
            required
          />
          <button
            type="button"
            className="auth-password-toggle"
            onClick={() => setShowConfirmPassword(v => !v)}
            tabIndex={-1}
            aria-label={showConfirmPassword ? t('hide') : t('show')}
          >
            {showConfirmPassword ? '🙈' : '👁'}
          </button>
        </div>
        <button className="auth-btn" type="submit" disabled={loading}>
          {loading ? t('registering') : t('register')}
        </button>
        <div className="auth-bottom-text">
          {t('hasAccount')} <Link to="/login" className="auth-link">{t('loginHere')}</Link>
        </div>
      </form>
    </div>
  );
}

export default RegisterPage;